import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { DataGrid,  GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import { useBranchContext } from '../../components/Context/BranchContext';
import { useNavigate } from 'react-router-dom';
import Chip from '@mui/material/Chip';

const columns = [
    {
        field: 'link',
        headerName: 'Link',
        width: 50,
        renderCell: (params) => (
            <i className="bi bi-info-circle"></i>
        ),
    },
    { field: 'name', headerName: 'Branch Name', width: 150 },
    { field: 'partnerName', headerName: 'Partner Name', width: 180 },
    { field: 'streetName', headerName: 'Street Name', width: 150, sortable: false },
    { field: 'buildingNumber', headerName: 'Building Number', width: 150 },
    { field: 'city', headerName: 'City', width: 150 },
    { field: 'state', headerName: 'State', width: 150 },
    {
        field: 'isActive',
        headerName: 'Status',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Active' : 'Inactive'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? 'green' : '#cf0a0a', // Dynamic color
                        color: 'white', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },

    {
        field: 'isApproved',
        headerName: 'Approved',
        width: 150,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex', // Use flexbox for centering
                    alignItems: 'center', // Vertically centers the chip
                    justifyContent: 'center', // Horizontally centers the chip
                    width: '100%', // Ensures full width
                    height: '100%', // Ensures full height
                }}
            >
                <Chip
                    label={params.value ? 'Approved' : 'Pending'} // Dynamic label
                    style={{
                        backgroundColor: params.value ? 'green' : 'blue', // Dynamic color
                        color: 'white', // Text color
                        fontWeight: 'bold', // Optional: Make the text bold
                    }}
                    size="small" // Makes the chip smaller
                />
            </div>
        ),
    },
    { field: 'zipCode', headerName: 'Zip Code', width: 150 },
    { field: 'country', headerName: 'Country', width: 150 },
    { field: 'phone', headerName: 'Phone', width: 150 },
    { field: 'email', headerName: 'Email', width: 150 },
];

export default function BranchTable() {
    const { branches } = useBranchContext();
    const navigate = useNavigate();

    const handleRowClick = (params) => {
        // Navigate to the edit form with the branch ID
        // navigate(`/edit-branch/${params.id}`, { state: { branch: params.row } });
        navigate(`/edit-branch/${params.id}/false`, { state: { branch: params.row } });
    };

    const handleAddBranch = () => {
        navigate('/newbranch');
    };

    const CustomToolbar = (props) => (
        <GridToolbarContainer>
        {/*    <EditToolbar {...props} />*/}
            <GridToolbar />
        </GridToolbarContainer>
    );
    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            handleAddBranch();
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    New Branch
                </Button>
            </GridToolbarContainer>
        );
    }

    return (
        <main id="main" className="main">
            <div className="pagetitle">
            <h1>Branch</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item"><a href="/allbranch">Branch</a></li>
                        
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">

                                <h5 className="card-title"></h5>
                                {/* Tabs */}
                                <Box sx={{ width: '100%' }}>
                                    <AppBar position="static" color="default">
                                        {/* AppBar content can go here */}
                                    </AppBar>
                                  
                                </Box>

                                <div style={{ height: '100%', width: '100%' }}>
                                    <DataGrid
                                        rows={branches}
                                        columns={columns}
                                        slots={{ toolbar: CustomToolbar }}
                                        onRowClick={handleRowClick} // Add this line to handle row clicks
                                        components={{ Toolbar: GridToolbar }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>
        </main>
    );
}
